module.exports = {
  tag: require('./flv-tag'),
  Transmuxer: require('./transmuxer'),
  getFlvHeader: require('./flv-header')
};



// WEBPACK FOOTER //
// ./src/muxjs/flv/index.js